import {
    PLCC_BANNER_REQUEST,
    PLCC_BANNER_SUCCESS,
    PLCC_BANNER_ERROR,
} from '../actionTypes/PLCCBannerActionTypes';

export const getRequestPLCCBanner = (requestFrom) => ({
    type: PLCC_BANNER_REQUEST,
    requestFrom,
});

export const getSuccessPLCCBanner = (plccBannerDetails) => ({
    type: PLCC_BANNER_SUCCESS,
    payload: plccBannerDetails,
});

export const errorPLCCBanner = (error) => ({
    type: PLCC_BANNER_ERROR,
    payload: error,
});
